import React from 'react';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Form, Input } from '@rocketseat/unform';
import { MdAddCircleOutline } from 'react-icons/md';
import { toast } from 'react-toastify';
import { Container, ButtonContainer } from './styles';
import api from '~/services/api';
import history from '~/services/history';

export default function FAQEditor({ location }) {
  const item =
    location.state && location.state.item ? location.state.item : undefined;

  const schema = Yup.object().shape({
    position: Yup.number('Should be a number')
      .nullable(true)
      .transform((value, originalValue) =>
        originalValue.trim() === '' ? null : value
      ),
    question: Yup.string().required('English question is required'),
    answer: Yup.string().required('English answer is required'),
    question_es: Yup.string(),
    answer_es: Yup.string(),
    question_pt: Yup.string(),
    answer_pt: Yup.string(),
  });

  async function handleSubmit(data) {
    try {
      if (item) {
        const response = await api.put(`faq/${item.id}`, data);
        history.push({
          pathname: '/faq',
        });
        toast.success(
          `The question '${response.data.question}' was successfully updated.`
        );
      } else {
        await api.post('faq', data);
        toast.success(
          `The question '${data.question}' was successfully created.`
        );
        history.push('/faq');
      }
    } catch (err) {
      toast.error(
        'Error while creating/updating this FAQ. Check the validations and try back later'
      );
    }
  }

  return (
    <Container>
      <Form schema={schema} initialData={item} onSubmit={handleSubmit}>
        <Input name="position" placeholder="Position" />
        <h2>English</h2>
        <Input name="question" placeholder="Question (English)" />
        <Input name="answer" multiline placeholder="Answer (English)" />
        <h2>Spanish</h2>
        <Input name="question_es" placeholder="Question (Spanish)" />
        <Input name="answer_es" multiline placeholder="Answer (Spanish)" />
        <h2>Portuguese</h2>
        <Input name="question_pt" placeholder="Question (Portuguese)" />
        <Input name="answer_pt" multiline placeholder="Answer (Portuguese)" />
        <ButtonContainer>
          <button type="submit">
            <MdAddCircleOutline color="#FFF" size={22} />
            Save FAQ
          </button>
        </ButtonContainer>
      </Form>
    </Container>
  );
}

FAQEditor.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      item: PropTypes.shape(),
    }),
  }).isRequired,
};
